import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { Switch } from "../../components/ui/switch";

export const PayPalSettings = ({ companyId }) => {
  const base = `/admin/companies/${companyId}/paypal`;
  const [f, setF] = useState(null);
  const [secret, setSecret] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(base).then((r) => setF(r.data)); }, [base]);
  if (!f) return null;
  const run = async (fn, ok) => {
    setBusy(true);
    try {
      await fn();
      toast.success(ok);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const save = async () => {
    setBusy(true);
    try {
      setF((await api.put(base, { ...f, secret })).data);
      setSecret("");
      toast.success("PayPal settings saved");
    } catch (e) {
      toast.error(errMsg(e));
      const saved = (await api.get(base)).data;
      setF((cur) => ({ ...cur, enabled: saved.enabled, has_secret: saved.has_secret, secret_hint: saved.secret_hint }));
    } finally {
      setBusy(false);
    }
  };
  const input = "mt-1 h-11 w-full rounded-xl border border-slate-300 px-3 text-sm";
  return (
    <div className="mt-3 space-y-4 rounded-2xl border border-slate-200 bg-white p-5" data-testid={`paypal-settings-${companyId}`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 font-display text-base font-bold text-[#0A2540]"><CreditCard size={18} />PayPal of this company</p>
        <label className="flex items-center gap-2 text-sm font-semibold text-slate-600">Active
          <Switch checked={f.enabled} onCheckedChange={(v) => setF({ ...f, enabled: v })} data-testid="paypal-enabled" /></label>
      </div>
      <p className="text-sm text-slate-500">When active, families can pay with PayPal the enrolments of events (and charters) organized by this company. Get Client ID and Secret from developer.paypal.com › Apps & Credentials. Use Sandbox keys for testing.</p>
      <div className="grid gap-4 md:grid-cols-2">
        <label className="text-xs font-semibold text-slate-600">Client ID<input value={f.client_id} onChange={(e) => setF({ ...f, client_id: e.target.value })} className={input} data-testid="paypal-client-id" /></label>
        <label className="text-xs font-semibold text-slate-600">Secret {f.has_secret && <span className="font-normal text-slate-400">(saved {f.secret_hint}, leave blank to keep)</span>}
          <input type="password" autoComplete="new-password" value={secret} onChange={(e) => setSecret(e.target.value)} className={input} data-testid="paypal-secret" /></label>
        <label className="text-xs font-semibold text-slate-600">Mode
          <select value={f.mode} onChange={(e) => setF({ ...f, mode: e.target.value })} className={input} data-testid="paypal-mode">
            <option value="sandbox">Sandbox (test)</option><option value="live">Live</option>
          </select></label>
      </div>
      <div className="flex flex-wrap gap-3">
        <button onClick={save} disabled={busy} className="btn-buoy !py-2 disabled:opacity-60" data-testid="paypal-save">Save PayPal</button>
        {f.has_secret && <button onClick={() => run(() => api.post(`${base}/test`), "PayPal credentials are valid")} disabled={busy} className="rounded-full border-2 border-[#0A2540] px-4 py-2 text-sm font-semibold text-[#0A2540]" data-testid="paypal-test">Test connection</button>}
      </div>
    </div>
  );
};
